import { create } from "zustand";
import { getMembers } from "../request/user";

export const useUserStore = create((set) => ({
  members: null,
  getMembers: async () => {
    const response = await getMembers();
    set({ members: await response?.data?.data });
  },
  selectedAssignees: null,
  setSelectedAssignees: (value) => {
    set({ selectedAssignees: value });
  },
}));
